import { createStore } from 'effector';
import { toggleChat, openChat, closeChat } from './events';

export const $isChatOpen = createStore(false)
    .on(toggleChat, (state) => !state)
    .on(openChat, () => true)
    .on(closeChat, () => false);
